<ws-ace-card [header]="(userSetup ? 'Additional ' : '') + userInstanceService.getSelectedInstance().name + ' Rights'">
    <ng-container card-body>
        @for (permission of assignedPermissions | sortBy: 'sequence'; track permission.instanceRightID) {
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                    <!-- select list of permissions for screen type -->
                    @if (editMode && userHasInstanceRight(permission)) {
                        <ws-select class="d-inline-block"
                                   style="width: 100px;"
                                   [ngModel]="permission.instanceRightID"
                                   (ngModelChange)="rightSelected($event, permission)"
                                   [options]="availablePermissionRights(permission.screenTypeID)"
                                   labelProperty="rights"
                                   valueProperty="instanceRightID">
                        </ws-select>
                    }
                    <!-- label if right is assigned but user does not have it-->
                    @if (!editMode || !userHasInstanceRight(permission)) {
                        <span style="width: 100px;"
                              class="application-permission-label d-inline-block">
                            {{ getPermissionLabel(permission.rightsID) }}
                        </span>
                    }
                    <!--screen type label -->
                    <span [ngStyle]="{'margin-left': ((editMode && userHasInstanceRight(permission)) ? '14px':'inherit')}">
                        {{ permission.screenType }}
                    </span>
                </div>

                <!-- delete button-->
                @if (editMode && userHasInstanceRight(permission)) {
                    <button type="button"
                            class="ace-btn has-icon btn-primary btn-danger"
                            (click)="deletePermission(permission)">
                        <i class="fa fa-trash"></i>
                    </button>
                }
            </div>
        }
        @if (editMode) {
            <div class="mt-2">
                <!-- add new right button-->
                @if (!(permissionToAdd || assignedPermissions.length === uniqueScreenTypes.length)) {
                    <button (click)="selectPermissionToAdd()"
                            class="ace-btn btn-sm btn-primary"
                            type="button">
                        Add Instance Right
                    </button>
                }
                @if (permissionToAdd) {
                    <div class="d-flex align-items-center mt-2">
                        <!-- permission selection-->
                        <ws-select [(ngModel)]="permissionToAdd.permission"
                                   [disabled]="!permissionToAdd.screenTypeID"
                                   [options]="screenTypePermissions"
                                   labelProperty="rights"
                                   [returnEntireOption]="true"
                                   style="width: 100px; display: inline-block;">
                        </ws-select>

                        <!-- screen type-->
                        <ws-select [ngModel]="permissionToAdd.screenTypeID"
                                   (ngModelChange)="screenTypeSelected($event)"
                                   [options]="uniqueScreenTypes | sortBy:'screenType' | filter: usablePermission"
                                   labelProperty="screenType"
                                   valueProperty="screenTypeID"
                                   style="width:auto; display: inline-block;">
                        </ws-select>

                        <!-- save button-->
                        <button (click)="addPermission()"
                                class="ace-btn has-icon btn-primary btn-success m-0 ms-2"
                                [disabled]="!permissionToAdd.permission"
                                style="margin-left: 10px;"
                                type="button">
                            <i class="fa fa-save"></i>
                        </button>
                        <!-- close button-->
                        <button (click)="cancelAddPermission()"
                                class="ace-btn has-icon btn-primary btn-danger m-1"
                                ng-hide="!permissionToAdd.permission"
                                type="button">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        }
    </ng-container>
</ws-ace-card>
